import type { IAngularStatic } from 'angular'

require('angular/angular')

const angular = (window as unknown as Window & { angular: IAngularStatic }).angular
;(globalThis as typeof globalThis & { angular?: IAngularStatic }).angular = angular

require('angular-ui-router/release/angular-ui-router')
require('angular-animate/angular-animate')
require('angular-aria/angular-aria')
require('angular-material/angular-material')
require('angular-material-data-table/dist/md-data-table')
require('restangular/dist/restangular')
require('angular-messages/angular-messages')
require('angular-cookies/angular-cookies')
require('angular-local-storage/dist/angular-local-storage')
require('ng-csv/build/ng-csv')
require('angular-sanitize/angular-sanitize')
require('angulartics/src/angulartics')
require('angulartics-google-analytics/lib/angulartics-ga')
require('highcharts-ng/dist/highcharts-ng')

export default angular
